import { render, staticRenderFns } from "./LinkSquareFlatIcon.vue?vue&type=template&id=694dfa08&scoped=true"
import script from "./LinkSquareFlatIcon.vue?vue&type=script&lang=js"
export * from "./LinkSquareFlatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694dfa08",
  null
  
)

export default component.exports